import { colors } from '../../assets/styles';
import {
  REALPAGE_EULA_URL,
  REALPAGE_PATENT_MARKING,
  REALPAGE_PRIVACY_POLICY_URL,
} from '../../config';
import styles from './styles';
import { Link } from 'react-router-dom';

export const Footer: React.FunctionComponent = () => {
  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footer}>
        <Link
          style={{ textDecoration: 'underline', color: colors.white, fontSize: '12px' }}
          to={REALPAGE_PATENT_MARKING}
          target='_blank'
          rel='noopener noreferrer'
        >
          Patent Marking
        </Link>
        <Link
          style={{ textDecoration: 'underline', color: colors.white, fontSize: '12px' }}
          to={REALPAGE_EULA_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          EULA Agreement
        </Link>
        <Link
          style={{ textDecoration: 'underline', color: colors.white, fontSize: '12px' }}
          to={REALPAGE_PRIVACY_POLICY_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default Footer;
